import Swal from "sweetalert2";
import { const_routes } from "../helpers/const_routes";
import { fetchToken } from "../helpers/fetch";
import { types } from "../types/types";
import { startLogout } from "./authActions";
import { t } from "i18next";
import { debugErrorActions, debugLogActions } from "../helpers/debugHelper";

export const startLoadingCatalogInstitutionsByLevel1 = (level) => {
  return async (dispatch) => {
    const resp = await fetchToken(`${const_routes.SCHEMA}`, `${const_routes.VERSIONV1}`, `${const_routes.ROUTE_CATALOGINSTITUTION}`, `getByLevel/${level}`);
    const body = await resp.json();

    debugLogActions(':: catalogInstitutionActions, startLoadingCatalogInstitutionsByLevel1', { 'body': body });

    if (body.ok) {

      dispatch(loadingCatalogInstitutionsLevel1(body.catalogInstitutions));
    } else {
      if (body.code === "bak-error-001") {
        Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`, "error");

      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
        Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

const loadingCatalogInstitutionsLevel1 = (cataloginstitutions) => ({
  type: types.CATALOGINSTITUTION_START_LOADING_LEVEL1,
  payload: cataloginstitutions,
});

export const startLoadingCatalogInstitutionByParent = (idParent, level) => {

  return async (dispatch) => {

    const resp = await fetchToken(
      `${const_routes.SCHEMA}`,
      `${const_routes.VERSIONV1}`,
      `${const_routes.ROUTE_CATALOGINSTITUTION}`,
      `getByParentId/${idParent}`
    );
    const body = await resp.json();

    if (body.ok) {

      if (level === 2) {
        dispatch(loadingCatalogInstitutionsLevel2ByParent(body.catalogInstitutions));
      } else if (level === 3) {
        dispatch(loadingCatalogInstitutionsLevel3ByParent(body.catalogInstitutions));
      } else if (level === 4) {
        dispatch(loadingCatalogInstitutionsLevel4ByParent(body.catalogInstitutions));
      } else if (level === 5) {
        dispatch(loadingCatalogInstitutionsLevel5ByParent(body.catalogInstitutions));
      } else if (level === 6) {
        dispatch(loadingCatalogInstitutionsLevel6ByParent(body.catalogInstitutions));
      }
    } else {
      if (body.code === "bak-error-001") {
        Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`, "error");

      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
        Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

export const startLoadingCatalogInstitutionByParentLocal = (idParent, level) => {

  return async (dispatch, getState) => {
    const state = getState();

    const { listFullCatalogInstitutions } = state.catalogInstitution;

    let catalogInstitutions = [];
    listFullCatalogInstitutions.forEach((item) => {
      if (item.parent_id === idParent) {
        catalogInstitutions.push(item);
      }
    })

    if (level === 2) {
      dispatch(loadingCatalogInstitutionsLevel2ByParent(catalogInstitutions));
    } else if (level === 3) {
      dispatch(loadingCatalogInstitutionsLevel3ByParent(catalogInstitutions));
    } else if (level === 4) {
      dispatch(loadingCatalogInstitutionsLevel4ByParent(catalogInstitutions));
    } else if (level === 5) {
      dispatch(loadingCatalogInstitutionsLevel5ByParent(catalogInstitutions));
    } else if (level === 6) {
      dispatch(loadingCatalogInstitutionsLevel6ByParent(catalogInstitutions));
    }

  };
};

const loadingCatalogInstitutionsLevel2ByParent = (cataloginstitutions) => ({
  type: types.CATALOGINSTITUTION_START_LOADING_LEVEL2,
  payload: cataloginstitutions,
});

export const selectCatalogInstitutionLevel1 = (cataloginstitution) => ({
  type: types.CATALOGINSTITUTION_SELECT_LEVEL1,
  payload: cataloginstitution,
});

const loadingCatalogInstitutionsLevel3ByParent = (cataloginstitutions) => ({
  type: types.CATALOGINSTITUTION_START_LOADING_LEVEL3,
  payload: cataloginstitutions,
});

export const selectCatalogInstitutionLevel2 = (cataloginstitution) => ({
  type: types.CATALOGINSTITUTION_SELECT_LEVEL2,
  payload: cataloginstitution,
});

const loadingCatalogInstitutionsLevel4ByParent = (cataloginstitutions) => ({
  type: types.CATALOGINSTITUTION_START_LOADING_LEVEL4,
  payload: cataloginstitutions,
});

export const selectCatalogInstitutionLevel3 = (cataloginstitution) => ({
  type: types.CATALOGINSTITUTION_SELECT_LEVEL3,
  payload: cataloginstitution,
});

const loadingCatalogInstitutionsLevel5ByParent = (cataloginstitutions) => ({
  type: types.CATALOGINSTITUTION_START_LOADING_LEVEL5,
  payload: cataloginstitutions,
});

export const selectCatalogInstitutionLevel4 = (cataloginstitution) => ({
  type: types.CATALOGINSTITUTION_SELECT_LEVEL4,
  payload: cataloginstitution,
});

const loadingCatalogInstitutionsLevel6ByParent = (cataloginstitutions) => ({
  type: types.CATALOGINSTITUTION_START_LOADING_LEVEL6,
  payload: cataloginstitutions,
});

export const selectCatalogInstitutionLevel5 = (cataloginstitution) => ({
  type: types.CATALOGINSTITUTION_SELECT_LEVEL5,
  payload: cataloginstitution,
});

export const selectCatalogInstitutionLevel6 = (cataloginstitution) => ({
  type: types.CATALOGINSTITUTION_SELECT_LEVEL6,
  payload: cataloginstitution,
});

export const cleanCatalogInstitutionLevel1 = () => ({
  type: types.CATALOGINSTITUTION_CLEAN_LEVEL1,
});

export const cleanCatalogInstitutionLevel2 = () => ({
  type: types.CATALOGINSTITUTION_CLEAN_LEVEL2,
});

export const cleanCatalogInstitutionLevel3 = () => ({
  type: types.CATALOGINSTITUTION_CLEAN_LEVEL3,
});

export const cleanCatalogInstitutionLevel4 = () => ({
  type: types.CATALOGINSTITUTION_CLEAN_LEVEL4,
});

export const cleanCatalogInstitutionLevel5 = () => ({
  type: types.CATALOGINSTITUTION_CLEAN_LEVEL5,
});

export const cleanCatalogInstitutionLevel6 = () => ({
  type: types.CATALOGINSTITUTION_CLEAN_LEVEL6,
});

export const startLoadingCatalogInstitutionByCode = (code) => {
  return async (dispatch) => {
    const resp = await fetchToken(`${const_routes.SCHEMA}`, `${const_routes.VERSIONV1}`, `${const_routes.ROUTE_CATALOGINSTITUTION}`, `getByLevel/${code}`);
    const body = await resp.json();

    if (body.ok) {

    } else {
      if (body.code === "bak-error-001") {
        Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`, "error");

      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
        Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

export const startLoadingCatalogInstitutions = () => {
  return async (dispatch) => {
    const resp = await fetchToken(`${const_routes.SCHEMA}`, `${const_routes.VERSIONV1}`, `${const_routes.ROUTE_CATALOGINSTITUTION}`, "get");
    const body = await resp.json();

    if (body.ok) {

      dispatch(loadingCatalogInstitutions(body.catalogInstitutions));
    } else {
      if (body.code === "bak-error-001") {
        Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`, "error");

      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
        Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

const loadingCatalogInstitutions = (catalogInstitutions) => ({
  type: types.CATALOGINSTITUTION_START_LOADING,
  payload: catalogInstitutions,
});

export const startLoadingCatalogInstitutionsPaginatedBk = (page, size) => {
  return async (dispatch) => {
    const resp = await fetchToken(`${const_routes.SCHEMA}`, `${const_routes.VERSIONV1}`, `${const_routes.ROUTE_CATALOGINSTITUTION}`, `get/${page}/${size}`);
    const body = await resp.json();

    debugLogActions(':: catalogInstitutionActions, startLoadingCatalogInstitutionsPaginated', { 'body': body });

    if (body.ok) {

      dispatch(loadingCatalogInstitutionsPaginated(body.catalogInstitutionPaginated));
    } else {
      if (body.code === "bak-error-001") {
        Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`, "error");

      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
        Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

export const startLoadingCatalogInstitutionsPaginated = (page, size, currentCatalogInstitution = {}) => {
  return async (dispatch) => {

    let institutionCode = "";
    if (currentCatalogInstitution && Object.keys(currentCatalogInstitution).length > 0) {
      institutionCode = currentCatalogInstitution.code;
    }

    const resp = await fetchToken(`${const_routes.SCHEMA}`, `${const_routes.VERSIONV1}`, `${const_routes.ROUTE_CATALOGINSTITUTION}`, `get/${page}/${size}/${institutionCode}`);
    const body = await resp.json();

    debugLogActions(':: catalogInstitutionActions, startLoadingCatalogInstitutionsPaginated', { 'body': body });

    if (body.ok) {

      dispatch(loadingCatalogInstitutionsPaginated(body.catalogInstitutionPaginated));
    } else {
      if (body.code === "bak-error-001") {
        Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`, "error");

      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
        Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

const loadingCatalogInstitutionsPaginated = (catalogInstitutionPaginated) => ({
  type: types.CATALOGINSTITUTION_START_LOADING_PAGINATED,
  payload: catalogInstitutionPaginated,
});

export const selectCatalogInstitutions = (catalogInstitution) => ({
  type: types.CATALOGINSTITUTION_SELECT,
  payload: catalogInstitution,
});

export const catalogInstitutionClean = () => ({
  type: types.CATALOGINSTITUTION_CLEAN,
});

export const catalogInstitutionStartDelete = (id) => {
  return async (dispatch) => {
    try {
      await Swal.fire({
        title: t("record_delete.title"),
        text: t("record_delete.text"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: t("titles.delete"),
      }).then((result) => {
        if (result.isConfirmed) {
          fetchToken(
            `${const_routes.SCHEMA}`,
            `${const_routes.VERSIONV1}`,
            `${const_routes.ROUTE_CATALOGINSTITUTION}`,
            `delete/${id}`,
            { deleted: false },
            "DELETE"
          )
            .then((resp) => resp.json())
            .then((body) => {
              if (body.ok) {
                dispatch(catalogInstitutionDeleted(id));
              } else {
                if (body.code === "bak-error-001") {
                  Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`, "error");

                }
                if (body.code === "bak-aut-tok-inv-001") {
                  Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
                  dispatch(startLogout());
                }
                if (body.code === "bak-aut-tok-inv-002") {
                  Swal.fire(t("titles.error"), t("api.token.timed_out"), "error");
                  dispatch(startLogout());
                }
              }
            });
          Swal.fire(t("titles.success"), t("record.delete"), "success");
        }
      });
    } catch (error) {
      debugErrorActions(':: catalogInstitutionActions, catalogInstitutionStartDelete', { 'error': error });
    }
  };
};

const catalogInstitutionDeleted = (id) => {
  return {
    type: types.CATALOGINSTITUTION_DELETE,
    payload: id,
  };
};

export const startSearchingCatalogInstitutionsPaginated = (textSearch, page, size) => {
  return async (dispatch) => {
    const resp = await fetchToken(
      `${const_routes.SCHEMA}`,
      `${const_routes.VERSIONV1}`,
      `${const_routes.ROUTE_CATALOGINSTITUTION}`,
      `search/${textSearch}/${page}/${size}`
    );
    const body = await resp.json();

    if (body.ok) {
      dispatch(searchingCatalogInstitutionsPaginated(body.catalogInstitutionsPaginated));
    } else {
      if (body.code === "bak-error-001") {
        Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`, "error");

      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
        Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

const searchingCatalogInstitutionsPaginated = (catalogInstitutionsPaginated) => ({
  type: types.CATALOGINSTITUTION_START_SEARCH_PAGINATED,
  payload: catalogInstitutionsPaginated,
});

export const cleanSearchingCatalogInstitutionsPaginated = () => ({
  type: types.CATALOGINSTITUTION_CLEAN_SEARCH_PAGINATED,
});

export const catalogInstitutionStartUpdate = (catalogInstitution, navigate) => {
  return async (dispatch) => {
    try {
      const resp = await fetchToken(
        `${const_routes.SCHEMA}`,
        `${const_routes.VERSIONV1}`,
        `${const_routes.ROUTE_CATALOGINSTITUTION}`,
        `update/${catalogInstitution.id}`,
        catalogInstitution,
        "PUT"
      );
      const body = await resp.json();

      if (body.ok) {
        dispatch(catalogInstitutionUpdated(catalogInstitution));

        Swal.fire({
          title: t("titles.success"),
          text: t("record.update"),
          icon: 'success',
          showCancelButton: false,
          confirmButtonColor: '#3085d6',
          confirmButtonText: t("buttons.close")
        }).then((result) => {
          if (result.isConfirmed) {
            setTimeout(() => {
              navigate("/admin-institution");
            }, 5000);
          }
        });

      } else {
        if (body.code === "bak-error-001") {
          Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`, "error");

        }
        if (body.code === "bak-aut-tok-inv-001") {
          Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-001"), "error");
          dispatch(startLogout());
        }
        if (body.code === "bak-aut-tok-inv-002") {
          Swal.fire(t("titles.error"), t("api.token.timed_out"), "error");
          dispatch(startLogout());
        }
      }
    } catch (error) {
      debugErrorActions(':: catalogInstitutionActions, catalogInstitutionStartUpdate', { 'error': error });
    }
  };
};

/**
 * Funcion para actualizar un evento en el store
 * @param {*} catalogInstitution
 * @returns
 */
const catalogInstitutionUpdated = (catalogInstitution) => {
  return {
    type: types.CATALOGINSTITUTION_UPDATE,
    payload: catalogInstitution,
  };
};

export const catalogInstitutionStartRegister = (catalogInstitution, navigate) => {
  return async (dispatch) => {
    const resp = await fetchToken(
      `${const_routes.SCHEMA}`,
      `${const_routes.VERSIONV1}`,
      `${const_routes.ROUTE_CATALOGINSTITUTION}`,
      "add",
      catalogInstitution,
      "POST"
    );

    const body = await resp.json();

    if (body.ok) {
      dispatch(catalogInstitutionRegister(body.catalogInstitution));

      Swal.fire({
        title: t("titles.success"),
        text: t("record.update"),
        icon: 'success',
        showCancelButton: false,
        confirmButtonColor: '#3085d6',
        confirmButtonText: t("buttons.close")
      }).then((result) => {
        if (result.isConfirmed) {
          setTimeout(() => {
            navigate("/admin-institution");
          }, 5000);
        }
      });

    } else {
      if (body.code === "bak-error-001") {
        Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`, "error");

      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
        Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

const catalogInstitutionRegister = (catalogInstitution) => ({
  type: types.CATALOGINSTITUTION_START_REGISTER,
  payload: catalogInstitution,
});

export const catalogInstitutionSetSearchText = (searchText) => ({
  type: types.CATALOGINSTITUTION_SET_SEARCH_TEXT,
  payload: searchText,
});

export const catalogInstitutionCleanSearchText = () => ({
  type: types.CATALOGINSTITUTION_SET_SEARCH_TEXT,
});

export const startLoadingCatalogInstitutionsAllByLevel6 = () => {
  return async (dispatch) => {
    const resp = await fetchToken(`${const_routes.SCHEMA}`, `${const_routes.VERSIONV1}`, `${const_routes.ROUTE_CATALOGINSTITUTION}`, `getByLevel/${6}`);
    const body = await resp.json();

    if (body.ok) {
      dispatch(loadingCatalogInstitutionsLevel6(body.cataloginstitutions_id));
    } else {
      if (body.code === "bak-error-001") {
        Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`, "error");

      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
        Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

const loadingCatalogInstitutionsLevel6 = (cataloginstitutions) => ({
  type: types.CATALOGINSTITUTION_START_LOADING_ALL_LEVEL6,
  payload: cataloginstitutions,
});

export const startLoadingCatalogInstitutionsAll = () => {
  return async (dispatch) => {
    const resp = await fetchToken(`${const_routes.SCHEMA}`, `${const_routes.VERSIONV1}`, `${const_routes.ROUTE_CATALOGINSTITUTION}`, `get`);
    const body = await resp.json();

    debugLogActions(':: catalogInstitutionActions, startLoadingCatalogInstitutionsAll', { 'body': body });
    if (body.ok) {
      dispatch(loadingCatalogInstitutionsAll(body.catalogInstitutions));
    } else {
      if (body.code === "bak-error-001") {
        Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`, "error");

      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
        Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

const loadingCatalogInstitutionsAll = (cataloginstitutions) => ({
  type: types.CATALOGINSTITUTION_START_LOADING_ALL,
  payload: cataloginstitutions,
});

export const startLoadingCatalogInstitutionsNoLevel6 = () => {
  return async (dispatch) => {
    const resp = await fetchToken(`${const_routes.SCHEMA}`, `${const_routes.VERSIONV1}`, `${const_routes.ROUTE_CATALOGINSTITUTION}`, `get`);
    const body = await resp.json();

    debugLogActions(':: catalogInstitutionActions, startLoadingCatalogInstitutionsAll', { 'body': body });

    if (body.ok) {

      let filterCatalogInstitutions = body.catalogInstitutions.filter(ele => ele.level < 3);

      const institutionWithoutParent = {

        id: 0,
        code: "0000",
        name: "SIN IDENTIFICACIÓN DE ID DE PADRE ",
        level: 0,
        deleted: false,
        code_visual: null,
        createdAt: "2022-10-05T05:20:20.958Z",
        updatedAt: "2022-10-05T05:20:20.958Z",
        parent_id: 9999

      }

      filterCatalogInstitutions.unshift(institutionWithoutParent);

      dispatch(loadingCatalogInstitutionsNoLevel6(filterCatalogInstitutions));
    } else {
      if (body.code === "bak-error-001") {
        Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`, "error");

      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
        Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

const loadingCatalogInstitutionsNoLevel6 = (cataloginstitutions) => ({
  type: types.CATALOGINSTITUTION_START_LOADING_NO_LEVEL6,
  payload: cataloginstitutions,
});

export const loadingCatalogInstitutionFilter = (catalogs) => ({
  type: types.CATALOGINSTITUTION_START_LOADING_FILTER,
  payload: catalogs,
});